module.exports = __webpack_public_path__ + "static/media/enviroment-retail.7478a9d5.svg";